














import Vue from 'vue';
import { ButtonModel, EntityType } from '@/types';
import EntityLockModal from '@/components/shared/EntityLockModal.vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'WorkflowJobLock',
  props: {
    lastActivity: {
      type: Date,
      required: true
    }
  },
  methods: {
    onButtonClicked(this: any, button: ButtonModel) {
      this.$emit('buttonClicked', button);
    }
  },
  computed: {
    ...mapGetters('workflowJobStore', ['workflowJob']),
    routeParams() {
      return { id: this.workflowJob.queueId.toString() };
    }
  },
  created(this: any) {
    this.buttons = [
      {
        caption: 'Return to queue',
        id: 'returnToQueue',
        class: 'mr-2',
        icon: 'undo-alt',
        variant: 'primary'
      }
    ] as ButtonModel[];
    
    this.entityType = EntityType.WorkflowJob;
    this.buttonRouteText = 'Return to queue';
    this.routeName = 'WorkflowQueue';
    this.storeNamespace = 'workflowJobStore';
  },
  components: {
    EntityLockModal
  }
});
